import styled from "styled-components";
import { useForm } from "react-hook-form";
import _ from "lodash";
import useScrollToTop from "edu_lms_v2/services/useScrollToTop";
import { setEventGTM } from "edu_lms/constants/googleTagManager";
import { SEARCH_LECTURE } from "edu_lms/constants/eventNameGTM";
import { useHocLieuStore } from "stores/hoclieuStore";
import { useQueryState } from "hooks/useQueryState";

export default function SearchForm() {
  useScrollToTop();
  const { register, handleSubmit } = useForm();

  const fetchHocLieu = useHocLieuStore((state) => state.fetchHocLieu);
  const textSearch = useHocLieuStore((state) => state.textSearch);
  const setTextSearch = useHocLieuStore((state) => state.setTextSearch);
  const setPage = useHocLieuStore((state) => state.setPage);

  const [queryTextSearch, setQueryTextSearch] = useQueryState("tieude");

  const onSubmit = (dataForm) => {
    setEventGTM({ event: SEARCH_LECTURE, search_key: dataForm.title });
    setTextSearch(dataForm.title);
    setPage(0);
    fetchHocLieu();
  };

  return (
    <form
      action=""
      method=""
      className="search-form pr m-0 col-md-5 px-0"
      onSubmit={handleSubmit(onSubmit)}
    >
      <div className="form-group flex pr">
        <StyledInput className="form-group">
          <input
            id="search"
            type="text"
            name="title"
            placeholder="Nhập tên học liệu cần tìm"
            required=""
            ref={register({ required: false })}
            value={textSearch}
            onChange={(e) => {
              setTextSearch(e.target.value);
              setQueryTextSearch(e.target.value);
            }}
          />
          {textSearch && (
            <ClearButton
              className="fa fa-times"
              aria-hidden="true"
              onClick={() => {
                setTextSearch("");
                setQueryTextSearch("");
                setPage(0);
                fetchHocLieu();
              }}
            />
          )}
        </StyledInput>
        <button type="submit" className="btn_submit btn-pr flex-center">
          Tìm Kiếm
        </button>
      </div>
    </form>
  );
}

const ClearButton = styled.i`
  position: absolute;
  right: 10px;
  top: 12px;
  cursor: pointer;
  color: hsl(0, 0%, 80%);

  &:hover {
    color: hsl(0, 0%, 50%);
  }
`;

const StyledInput = styled.div`
  position: relative;
  width: calc(100% - 140px);

  input {
    width: 100%;
  }
`;
